import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../util/api";

const deleteData = async (id: string) => {
  return await api.delete("/aluno?id=" + id);
};

export function useStudentDelete() {
  const queryClient = useQueryClient();
  const mutate = useMutation({
    mutationFn: deleteData,
    onSuccess: () => {
      queryClient.invalidateQueries(["students-data"]);
    },
  });

  return mutate;
}
